import { defineStore } from "pinia";

type State = {
    isModalOpen : boolean,
    successMessage? : string,
    warningMessage? : string,
    errorMessage? : string,
}

export const useModalStore = defineStore('modal', {
    state: () : State => {
        return {
            isModalOpen: false,
            successMessage: '',
            warningMessage: '',
            errorMessage: '',
        }
    },
    actions: {
        setIsOpenModal(isOpen : boolean) : void {
            this.isModalOpen = isOpen;
        },
        resetModal() : void {
            this.$reset();
        },
        setSuccessMessage(message : string) : void {
            this.successMessage = message;
        },
        setWarningMessage(message : string) : void {
            this.warningMessage = message;
        },
        setErrorMessage(message : string) : void {
            this.errorMessage = message;
        },
    },
    getters: {
        isOpen() : boolean {
            return this.isModalOpen;
        },
        isSuccessMessage() : boolean {
            return !!this.successMessage?.length
        },
        isWarningMessage() : boolean {
            return !!this.warningMessage?.length
        },
        isErrorMessage() : boolean {
            return !!this.errorMessage?.length
        },
        getSuccessMessage() : string {
            return (this.successMessage ?? '');
        },
        getWarningMessage() : string {
            return (this.warningMessage ?? '');
        },
        getErrorMessage() : string {
            return (this.errorMessage ?? '');
        },
    },
});
